import React, { useState, useEffect, useMemo } from 'react'
import { BlobDocumentApi, type BlobDocumentDto } from '../../../common/services'
import pdf from '../../../assets/images/mc-file-pdf.svg'
import unKnown from '../../../assets/images/mc-file-unknown.svg'
import sheet from '../../../assets/images/mc-file-spreadsheet.svg'
import png from '../../../assets/images/mc-file-image.svg'

const icons: Record<string, string> = {
  pdf,
  unKnown,
  sheet,
  png
}

interface RenderImageCellProps {
  row: BlobDocumentDto
}

const RenderImageCell = ({ row }: RenderImageCellProps): JSX.Element => {
  const [imageUrl, setImageUrl] = useState<string | null>(null)

  const fileType = useMemo(() => row.type?.split('/').pop()?.toLowerCase(), [row.type])

  const iconUrl = useMemo(() => {
    if (fileType === 'vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
      return icons.sheet
    }
    return icons[fileType ?? 'unKnown'] ?? icons.unKnown
  }, [fileType])

  useEffect(() => {
    if (['image/jpeg', 'image/png'].includes(row.type ?? '') && ((row?.id) != null)) {
      void fetchImage(row.id)
    }
  }, [row.id])
  const fetchImage = async (id: number): Promise<void> => {
    try {
      const response = await new BlobDocumentApi().apiV2BlobDocumentDownloadBlobDocumentGet(
        id,
        { responseType: 'blob' }
      ) as any

      const url = URL.createObjectURL(response.data)
      setImageUrl(url)
    } catch (error) {
      console.error('Failed to load image', error)
    }
  }

  if (['image/jpeg', 'image/png'].includes(row.type ?? '')) {
    return (imageUrl != null)
      ? (
      <img
        width={50}
        height={30}
        style={{ objectFit: 'contain', cursor: 'pointer' }}
        src={imageUrl}
        alt={row.name ?? ''}
      />
        )
      : (
      <div style={{ width: 50, height: 30, backgroundColor: '#f0f0f0' }} />
        )
  }

  return (
    <img
      width={50}
      height={30}
      style={{ objectFit: 'contain' }}
      src={iconUrl}
      alt={row.name ?? ''}
    />
  )
}

export default RenderImageCell
